// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"8":"mobile","380":"desktop"}[chunkId] || chunkId) + "." + {"8":"c9afe625cc45ab91a144","68":"7489f6d8d68f4aaa0e3f","255":"32873ad73d617d3bc99d","380":"96c1931d75f89112cf05","966":"84e453136c9ef4301099","980":"f1ce3ab45eb44a618670"}[chunkId] + ".js";
};